import { Component, Input, OnInit } from '@angular/core';
import { Student } from '../../../../models/student.model';

@Component({
    selector: 'app-student-detail-general',
    templateUrl: './student-detail-general.component.html',
    styleUrls: ['./student-detail-general.component.scss']
})
export class StudentDetailGeneralComponent implements OnInit {

    @Input() student: Student;

    ngOnInit() : void { }

    public getDNI(): string {
        return this.student.dni ? this.student.dni : 'Desconocido';
    }

}
